import { MoveableBookFeature } from './moveable-book-feature';
import { environment } from '../../environments/environment';
import { Loggable } from './loggable';
import { Modalable, ResponseStatus } from './modalable';
import { TechnicalFeature } from '@lemberger/lemberger-am';

export class Link extends MoveableBookFeature implements Loggable, Modalable {
    static MODAL_ID = 'link-Modal';
    logType = TechnicalFeature.Link;
    tool: null;
    content: string;
    url: string;
    overlay: boolean;
    type: number;
    wasClicked: boolean;
    zIndex = 4;
    bypassCheck = false;
    status: ResponseStatus;
    /**
     * For some QuickLinks there should be an AreaLink beside the Quicklink.
     * This flag tells if this object is such a Link.
     */
    isSolutionLink?: boolean;

    getStatus(): ResponseStatus {
        return this.status;
    }

    getEndpointName(): string {
        return environment.endpointUrls.links;
    }

    getModalId(): string {
        return Link.MODAL_ID;
    }

    canBypassCheck(): boolean {
        return this.bypassCheck;
    }

}
